import { render, staticRenderFns } from "./AppointmentListCardSkeleton.vue?vue&type=template&id=0ebfb7ce&scoped=true"
import script from "./AppointmentListCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./AppointmentListCardSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebfb7ce",
  null
  
)

export default component.exports